export default "__VITE_ASSET__nxedpcfL__"